import $axios from '@/plugins/axios-instance'

export default {
    state: {
        newsList: []
    },

    getters: {
        getNewsList(state) {
            return state.newsList
        }
    },

    actions: {
        getNews(context, data) {
            return  $axios.get(`/News/List?page=${data.page}&count=10`)
            .then((response) => {
                context.state.newsList = response.data.models
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },
        
        newsList(context) {
            return  $axios.get('/News/List')
            .then((response) => {
                context.state.newsList = response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },
        
        newsDetail(context, data) {
            return  $axios.get('/News/Detail?id='+data.id)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },
        
        newsCreate(context, data) {
            return $axios.post('/News/Create', data)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },
        
        newsEdit(context, data) {
            return $axios.post('/News/Edit', data)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },
        
        newsDelete(context, data) {
            return $axios.delete('/News/Delete?id='+data.id)
            .then((response) => {
                context.state.newsList.splice(data.index, 1)
            }).catch((e)=>{
                throw(e.response)
            })
        },


    }
}